<template>
  <div class="modal-body">
    <div style="position:relative">
      <el-page-header @back="goBack" content="培训合格率汇总"></el-page-header>
      <div class="btn" @click="isShow=!isShow">
        <!-- <el-button type="primary" size="mini">筛选</el-button>
         -->
            <i size="mini" class="filter_style" style="color:#fff" :class="isShow==false?'el-icon-arrow-down':'el-icon-arrow-up'"><span>筛选</span></i>
      </div>
    </div>
    <div  style="width:100%;overflow:auto" :style="{ height: height+'px'}" v-loading="chartLoading">
      <div class="option" v-show="isShow">
      <el-form class="form-style" ref="params" :model="params" size="mini" label-width="70px">
        <el-form-item label="开始日期" prop="BeginDate">
          <el-date-picker style="width: 120px;"
            @change="(val)=>{changeBeginDate(val)}"
            v-model="BeginTime"
            type="month"
            format="yyyy年MM月"
            value-format="yyyy-MM"
            placeholder="开始日期"
            clearable
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="结束日期" prop="EndDate">
          <el-date-picker style="width: 120px;"
            @change="(val)=>{changeEndDate(val)}"
            v-model="EndTime"
            type="month"
            format="yyyy年MM月"
            value-format="yyyy-MM"
            placeholder="结束日期"
            clearable
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="事业部" prop="College">
          <el-select v-model="params.College" placeholder="请选择事业部" style="width: 120px;" @change="selectProject" clearable>
            <el-option v-for="item in Colleges" :key="item.Id" :label="item.Name" :value="item.Id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分线" prop="Branch">
          <el-select v-model="params.Branch" placeholder="请选择分线" style="width: 120px;" @change="getQuery" clearable>
            <el-option v-for="item in productLine" :key="item.Id" :label="item.Name" :value="item.Id"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="课程" prop="ProjectId">
          <div class="cascader_box">
            <el-cascader popper-class="cascader_box_Id" style="width: 120px;" v-model="params.courseId" :options="course_options"
              :props="cascaderProps" size="mini" :show-all-levels="false" :change-on-select='false'
              filterable placeholder="选择课程" @visible-change="changeCourse($event)">
            </el-cascader>
          </div>
          
        </el-form-item> -->
      </el-form>
      </div>
      <div id="main1" style="width:100%;min-height:500px"></div>
      <!-- <div id="main2" style="width:100%;min-height:240px"></div> -->
      <div id="main3" style="width:100%;min-height:240px"></div>
    </div>

    <el-drawer title="筛选" :visible.sync="showDialog" @close="close">
      
    </el-drawer>

    <div class="popup_box" v-if="showPopup">
      <div class="popup">
        <div style="padding:10px;text-align:center;font-size:16px">选择课程</div>
        <el-cascader-panel v-model="chooseCourse" :options="course_options" :props="cascaderProps1"></el-cascader-panel>
        <div style="padding:10px 0 4px; text-align: center;">
          <el-button type="primary" size="mini" @click="saveDialog">保存</el-button>
          <el-button size="mini" type="primary" @click="closeDialog">关闭</el-button> 
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import { getBaseUrl,GetFenLeiList,GetProjectList,AllCourseCascaderOption,GetTrainPassRateKpi} from "../../api/api";
import moment, { min } from "moment";
import echarts from 'echarts'

export default {
  
  data() {
    return {
      chartLoading: false,
      baseUrl: getBaseUrl(),
      height:0,
      loading:false,
      loadingsave:false,
      date:'2021年1月',
      business:[], // 事业部
      productLine:[], //产品线
      relationProject:[], //项目
      course_options:[], //课程
      showDialog:false,
      isShow:false,
      PassData:[],
      UnPassData:[],
      AvgPass:[],
      dataList:[],
      DsTrainTypeList:[],
      DsRegionList:[],
      proportion2:[],
      Colleges:[],
      BeginTime: '',
      EndTime: '',
      params:{
        TrainerId: 0,
        BeginDate: "",
        EndDate: "",
        College: "",
        Branch: "",
        CourseId: 0,
        SearchKey: ""
      },
      cascaderProps: {
        label: "Name",
        value: "KeyStr",
        children: "Children",
        emitPath: false,
        multiple: true, 
        checkStrictly:true
      },
      cascaderProps1:{
        label: "Name",
        value: "KeyStr",
        children: "Children",
        emitPath: false,
        checkStrictly:true,
        multiple: true, 
        disabled:"Disabled" 
      },
      chooseCourse:[],
      showPopup:false,
      colors:[
            ["#4a7fb0","#adc6e5",  "#c6ccd4"],
            ["#4a7fb0","#adc6e5", "#96bfee",  "#c6ccd4"],
            ["#a1c788","#b9b9b9","#96bfee","#60a0e8", "#96bfee",  "#c6ccd4"]
      ],
    };
  },
  mounted() {
    this.height = window.innerHeight - 80; 
    this.GetFenLeiList();
    // this.getCourse();
    this.search()
  },
  methods: {
    search(){
      this.chartLoading = true;
      // GetTrainKpi(this.params).then();
      GetTrainPassRateKpi(this.params).then((res) => {
        if (res.data.Code != 1) return;
        
        this.dataList = res.data.Data;
        
        this.DsRegionList =[];
        this.proportion2=[];

        this.dataList.forEach(e=>{
         
          if(this.DsRegionList.indexOf(e.Region)<0)
          {
              this.DsRegionList.push(e.Region);
          }
          //this.seriesList.push({name:e.TrainType,type: "bar",data:[e.Value],label:{show:true}}) 
        })
        this.PassData=new Array(this.DsRegionList.length);
        this.UnPassData =new Array(this.DsRegionList.length);
        this.AvgPass=new Array(this.DsRegionList.length);
        var passcout=0;
        var unpasscount=0;
        this.dataList.forEach(e=>{ 
          if(e.TrainType=='一次合格人数')
          {
              this.PassData[this.DsRegionList.indexOf(e.Region)]=e.Value;
              passcout+=e.Value;
          }
          else
          {
              this.UnPassData[this.DsRegionList.indexOf(e.Region)]=e.Value;
              unpasscount+=e.Value;
          }
        })

        this.proportion2.push({value: passcout, name: '一次合格人数' });
        this.proportion2.push({value: unpasscount, name: '不合格人数' });
        for(var i=0;i<this.PassData.length;i++)
        {
          if(!this.PassData[i])
          {
            this.PassData[i]=0;
          }
          if(!this.UnPassData[i])
          {
            this.UnPassData[i]=0;
          }
          this.AvgPass[i] = (this.PassData[i]+this.UnPassData[i])==0?0: Math.floor(this.PassData[i]*100.0/(this.PassData[i]+this.UnPassData[i]))
        }
 
      
        setTimeout(() => {
          this.initChart();
          this.myChart3(); 
          this.chartLoading = false;
        }, 100);
      });
    },
    initChart(){
      // 基于准备好的dom，初始化echarts实例
      var myChart = echarts.init(document.getElementById('main1'));
      // var xData = function() {
      //     var data = [];
      //     for (var i = 1; i < 13; i++) {
      //         data.push(i + "月");
      //     }
      //     return data;
      // }();

      var option = {
        color:this.colors[0],
        backgroundColor: "transparent",//#344b58
        title: {
          text: "培训合格率汇总",
          top:15,
          left: 'center',
          textStyle: {
            color: '#000',
            fontSize: '16'
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
            textStyle: {
              color: "#fff"
            }
          },
        },
        grid: {
          borderWidth: 0,
          top: "30%",
          left:10,
          width:'94%',
          textStyle: {
            color: "#fff"
          },
          containLabel: true,
        },
        legend: {
          left: '8%',
          top: '12%',
          textStyle: {
            color: '#90979c',
          },
          data: ['一次合格人次', '不合格人次', '合格率']
          // data:this.PassData
          // data: this.DsTrainTypeList,
        },
        calculable: true,
        xAxis: [{
          type: "category",
          data: this.DsRegionList,
          axisPointer: {
            type: 'shadow'
          },
          min:8, 
          axisLabel:{
              formatter: function (value) {
                return 1*value.substring(value.length-2)
              }
            }, 
        }],
        yAxis: [
          {
            type: 'value',
            name: '人数',
            min: 0,
            axisLabel: {
              formatter: '{value}'
            }
          },
          {
            type: 'value',
            name: '通过率',
            min: 0,
            axisLabel: {
              formatter: '{value}%'
            }
          }
        ],
        dataZoom: [{
            show: true,
            height: 30,
            xAxisIndex: [
                0
            ],
            bottom: 10,
            start: 1,
            end: 100,
            handleIcon: 'path://M306.1,413c0,2.2-1.8,4-4,4h-59.8c-2.2,0-4-1.8-4-4V200.8c0-2.2,1.8-4,4-4h59.8c2.2,0,4,1.8,4,4V413z',
            handleSize: '110%',
            handleStyle:{
                color:"#d3dee5",
                
            },
            textStyle:{  color:"#fff"},
            borderColor:"#90979c"
        }, {
            type: "inside",
            show: true,
            height: 15,
            start: 1,
            end: 35
        }],
        series: [ 
        {
            name: "一次合格人次",
            type: "bar",
            stack: "总量",
            // barMaxWidth: 15,
            label: {
              show: true
            },
            data: this.PassData,
          },
          {
            name: "不合格人次",
            type: "bar",
            stack: "总量",
            // barWidth:30,
            label: {
              show: true
            },
            data: this.UnPassData,
          },
          {
            name: "合格率",
            type: "line",
            yAxisIndex: 1,
            label: {
              show: true,  
            },
            axisLabel: {
              formatter: function(value) {
                   if(value == 0) {
                       return value;
                   }else {
                       return value*100+'%';
                  }
                        
               }
            },
            data: this.AvgPass,
          },
        ]
       
      }
      myChart.setOption(option);
    },

    myChart3(){
      var myChart3 = echarts.init(document.getElementById('main3'));
      var option = {
        color:this.colors[2],
        title: {
          left: 'center',
          top: 10,
          bottom:'10%',
          text: '总累计合格率',
          textStyle: {
            color: '#000',
            fontSize: 16
          },
        },
        label: {
          normal: {
            formatter: '{c}',
            position: 'inside'
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c}'
        },
        legend: {
          orient: 'vertical',
          left: 20,
          top:'15%',
          // data: this.DsTrainTypeList, 
          // data:this.DsTrainTypeList ,
          data: ['不合格人数','一次合格人数'],
        },
        series: [{
          name: '总累计合格率: ',
          type: 'pie', 
          top:40,
          left:'10%',
          radius: '70%',
          labelLine: {
            show: false
          },
          label: {
            position: 'inner',
            show: true,
            // formatter:'{b} : \n{d}%',
            formatter:'\n{d}%',
            fontSize: 12
          },
          // data: [{value:75,name:'一次合格人次'},{value:25,name:'不合格人次'}],
          data:this.proportion2,
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }]
      };
      myChart3.setOption(option);
    },
    
    
    showSearch(){
      this.showDialog = true;
      this.GetFenLeiList();
      this.getMainProgect();
      this.getCourse();
    },
    // 事业部
    GetFenLeiList(){
      GetFenLeiList(-1).then(res=>{
        if(res.data.Code != 1) return;
        // this.business = res.data.Data;
        this.Colleges = res.data.Data;
      })
    },
    selectProject(val){
      this.params.College='';
      this.productLine =[];
      this.Colleges.forEach(e=>{
        if(e.Id==val)
        {
          this.params.College= e.Name;
        }
      });
      GetFenLeiList(val).then(res=>{
        if(res.data.Code != 1) return;
        // this.business = res.data.Data;
        this.productLine = res.data.Data;
      })
      this.params.Branch = ''
        this.search();
    },
    getQuery(val){
      // this.params.College = ''
      this.search();
    },
    // 获取项目数组
    // getMainProgect(){
    //   GetProjectList().then(res=>{
    //     if(res.data.Code != 1) return;
    //     this.relationProject = res.data.Data; 
    //   })
    // },
    // 获取课程
    getCourse() {
      AllCourseCascaderOption().then(res => {
        this.course_options = res.data.Data;
      });
    },
    // changeCourse(){
    // },
    changeCourse(event){
      if(event){
        // this.showPopup = true;
      }
    },
    saveDialog(){
      // this.searchModel.courseId = this.chooseCourse;
      let newList = [];
      this.chooseCourse.forEach(e=>{
        newList.push(e)
      })
      this.params.courseId = newList;
      this.showPopup = false;

    },
    closeDialog(){
      this.showPopup = false;
    },

    // changeBeginDate(val){
    //   var endTime = this.params.EndDate;
    //   var start = moment(new Date(val)).format("YYYY-MM"); //开始时间
    //   var end = moment(new Date(endTime)).format("YYYY-MM"); //结束时间
    //   if(start>end){
    //     this.$message.error('开始日期不能大于结束日期');
    //     this.params.BeginDate = '';
    //     return;
    //   }
    // },
        changeBeginDate(val) {
      var endDate = this.EndTime;
      if(val){
        var start = moment(new Date(val)).format("YYYY-MM"); //开始时间
        var end; //结束时间
        if (endDate) {
          end = moment(new Date(endDate)).format("YYYY-MM"); //结束时间
        }
        if (end&& start > end) {
          this.$message.error("开始日期不能大于结束日期");
          this.params.BeginDate = "";
          return;
        }
        this.params.BeginDate = start;
        this.params.EndDate = end;
      }
      else{
        this.params.BeginDate =''
      }
      this.search();
    },
    changeEndDate(val) {
      var beginDate = this.BeginTime;
      if(val){
          var end = moment(new Date(val)).format("YYYY-MM"); //开始时间
          if(beginDate)
          {
              var start = moment(new Date(beginDate)).format("YYYY-MM"); //结束时间
              if (end < start) {
                this.$message.error("结束日期不能小于开始日期");
                this.params.EndDate = "";
                return;
              }
          } 
          this.params.EndDate = end;
      }
      else{
        this.params.EndDate = '';
      }
      this.search();
    },
    // changeEndDate(val){
    //   var startTime = this.params.BeginDate;
    //   var end = moment(new Date(val)).format("YYYY-MM"); //开始时间
    //   var start = moment(new Date(startTime)).format("YYYY-MM"); //结束时间
    //   if(end<start){
    //     this.$message.error('结束日期不能小于开始日期');
    //     this.params.EndDate = '';
    //     return;
    //   }
    //   this.search();
    // },
    saveplans(){
    //   this.loadingsave = true;
      this.showDialog = false;
      this.search();
    //   api(this.searchModel).then(res=>{
    //     this.loadingsave = false;
    //     if(res.data.Code != 1) return;
    //     this.showDialog = false;
    //     this.search();
    //   })
      this.close();
    },
    close(){
      this.params = {
        // StartTime:'',
        // EndTime:'',
        // SybId:'',
        // CpxId:'',
        // Type:'',
        // ProjectId:'',
        // courseId:'',
      }
    },
    goBack() {
       window.history.go(-1)
      // try {
      //   flutter_page_back.postMessage(this.fid + "");
      // } catch (error) {
      //   Toast("返回失败1：" + JSON.stringify(error));
      // }
    }, 
    
  },
  watch:{
  
  }
};
</script>

<style lang="less" scoped>
html,
body {
  height: 100%;
}
.modal-body {
  overflow: hidden;
  height: 100%;
  padding: 0;
  font-size: 14px;
  font-family: "Helvetica Neue", Arial, "PingFang SC", "Hiragino Sans GB",
    "\5B8B\4F53", "Microsoft Yahei", sans-serif;
}
/deep/.el-button--mini{
 background-color: rgb(32, 148, 244);
 border: 1px solid rgb(32, 148, 244);
}
.el-page-header{
    height: 80px;
    background: rgb(32, 148, 244);
    // display: flex;
    align-items: flex-end;
    color: #fff;
    padding: 0 10px 10px;
    box-sizing: border-box;
}
.btn{
    position: absolute;
    top: 44px;
    right: 5px;
    z-index: 999;
}
.popup_box{
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    background: rgba(0,0,0,0.3);
  }
  .popup{
    width: 360px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    padding: 0 0 10px 0;
    border-radius: 5px;
    box-sizing: border-box;
    z-index: 9999;
  }
/deep/ .el-page-header__content{
    color: #fff;
    font-size: 16px;
    font-weight: 600;
    // margin-left: 16%;
    width: calc(100% - 188px);
    text-align: center;
}
/deep/ .el-page-header__left::after{
    display: none;
}

/deep/ .el-drawer{
    width: 70%!important;
}
.option{
  display: flex;
  flex-direction: row;
}
.form-style{
  display: flex;
  justify-content:center;
  align-items: center;
  flex-direction: row;
  margin-bottom: -15px;
  flex-wrap: wrap;
  width: 100%;
  margin: 10px auto;
  /deep/.el-form-item{
    width: 50%;
    margin-bottom: 22px;
  }
}
/deep/.el-form-item__label{
 padding-right: 3px;
 margin-left: 0%;
}
/deep/.el-form-item__content{
  margin-left: -40px;
}
/deep/.el-form-item--mini.el-form-item{
  margin-left: -12px;
  margin-bottom: 7px;
}
/deep/.el-form-item__label {
 padding-right: 1px;
}
</style>
<style lang='scss' >
  .cascader_box_Id{
    width: 100%;
    overflow-x: auto;
    // background: pink;
  }
  /deep/.el-button--success{
  background: rgb(32, 148, 244);
  border: 1px solid rgb(32, 148, 244);
}
/deep/.el-button--mini{
 background-color: rgb(32, 148, 244);
 border: 1px solid rgb(32, 148, 244);
}
.filter_style{
  margin-top: 6px;
  span{
    padding-left: 4px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/report/PassRate.vue